import { cva } from 'class-variance-authority';

type CalloutProps = {
  children: React.ReactNode;
  className?: string;
  variant?: 'accent' | 'secondary' | 'vip' | 'disabled';
  'data-testid'?: string;
};

const container = cva('paragraph-callout h-6 px-2 rounded-sm inline-flex items-center gap-1 align-middle select-none', {
  variants: {
    variant: {
      accent: 'bg-accent-green text-secondary',
      secondary: 'bg-container text-foreground',
      vip: 'bg-vip text-vip-text font-medium',
      disabled: 'bg-container text-foreground opacity-50',
    },
  },
  defaultVariants: {
    variant: 'accent',
  },
});

function Callout({ children, className, variant = 'accent', 'data-testid': dataTestId }: CalloutProps) {
  const classes = container({ variant, className });

  return (
    <div className={classes} data-testid={dataTestId}>
      {children}
    </div>
  );
}

export { Callout, type CalloutProps };
